export default __webpack_public_path__ + "img/f131671d373a38e47bf4e76944f0736d.svg";